import { OidcClient, UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts'
import { Constants } from '../helpers/Constants'

export const RedirectUri = '/signin-callback.html'
export const SilentRedirectUri = '/silent-renew.html'
export const PostLogoutRedirectUri = '/index.html'

const Settings: UserManagerSettings = {
  authority: Constants.stsAuthority,
  client_id: 'Interfleet',
  redirect_uri: location.origin + RedirectUri,
  silent_redirect_uri: location.origin + SilentRedirectUri,
  post_logout_redirect_uri: location.origin + PostLogoutRedirectUri,
  response_type: 'code',
  scope:
    'openid profile contracts customers reports roles documents offline_access phone email orders locations notifications tags permissions',
  loadUserInfo: true,
  automaticSilentRenew: true,
  filterProtocolClaims: false,
  stateStore: new WebStorageStateStore({
    store: window.localStorage,
    prefix: 'oidc.',
  }),
  userStore: new WebStorageStateStore({
    store: window.sessionStorage,
    prefix: 'oidc.',
  }),
}

const SettingsPrimary: UserManagerSettings = {
  ...Settings,
  stateStore: new WebStorageStateStore({
    store: window.localStorage,
    prefix: 'oidc.primary.',
  }),
  userStore: new WebStorageStateStore({
    store: window.sessionStorage,
    prefix: 'oidc.primary.',
  }),
}

export const OIDC_CLIENT = new OidcClient(Settings)
export const USER_MANAGER = new UserManager(Settings)
export const USER_MANAGER_PRIMARY = new UserManager(SettingsPrimary)
